.wrapper {
  min-height: 60vh;
  display: grid;
  place-content: center;
  gap: 1rem;
  padding: 2rem;
  text-align: center;
}

.details {
  margin: 0 auto;
  max-width: 40rem;
  overflow: auto;
  border-radius: 0.75rem;
  border: 1px solid var(--color-border);
  background: var(--color-surface-strong);
  color: var(--color-text);
  padding: 1rem;
  text-align: left;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}
